import styled from 'styled-components'
import { colors } from '../../styles/base/_allBase.styles'

export const Hero = styled.section`
  position: relative;
  padding: 11.2rem 2.4rem 3.6rem;
  background: ${({ $variant }) => $variant === 'destination' ? colors.warmPalette.neutralLight : colors.coolPalette.neutralLight};
  color: ${colors.warmPalette.primaryDark};
  @media (max-width: 599px) { padding: 9rem 2rem 2.8rem; }
`
export const HeroInner = styled.div`
  width: min(118rem, 100%);
  margin: auto;
  display: grid;
  grid-template-columns: ${({ $hasImage }) => $hasImage ? 'minmax(0, 1.1fr) minmax(0, 1fr)' : 'minmax(0, 1fr)'};
  align-items: center;
  gap: clamp(2.4rem, 5vw, 7rem);
  @media (max-width: 767px) { grid-template-columns: 1fr; gap: 2.4rem; }
`
export const HeroCopy = styled.div`
  min-width: 0;
  h1 { margin: 0; font-family: 'Whyte-Bold', sans-serif; font-size: ${({ $variant }) => $variant === 'destination' ? 'clamp(3.6rem, 4.5vw, 6.4rem)' : 'clamp(3.2rem, 3.2vw, 4.8rem)'}; line-height: 1.1; letter-spacing: -.025em; overflow-wrap: break-word; text-wrap: balance; }
  p { max-width: 54ch; margin: 1.6rem 0 0; color: ${colors.neutralPalette.greyDark}; font-size: 1.8rem; line-height: 1.55; }
  a { margin-top: 2.4rem; }
`
export const HeroImage = styled.div`
  position: relative;
  min-width: 0;
  height: ${({ $variant }) => $variant === 'destination' ? '42rem' : $variant === 'venue' ? '30rem' : '22rem'};
  overflow: hidden;
  border-radius: .6rem;
  img { object-fit: cover; }
  @media (max-width: 767px) { height: ${({ $variant }) => $variant === 'destination' ? '25rem' : '18rem'}; display: ${({ $variant }) => $variant === 'directory' ? 'none' : 'block'}; }
`
